/**
 * SEO config for Mrs Cater Caterer app focused on discoverability
 * of partner portals and profile management.
 */

const DEFAULT_BASE =
  typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_URL
    ? String(import.meta.env.VITE_APP_URL).replace(/\/$/, '')
    : typeof window !== 'undefined'
      ? window.location.origin
      : 'https://caterer.mrscater.com';

export const SEO = {
  baseUrl: DEFAULT_BASE,
  defaultTitle:
    'Mrs Cater Caterer Portal | Manage Your Catering Business',
  defaultDescription:
    'Mrs Cater Caterer Portal for South African catering businesses. Manage your profile, menu, bids, orders and secure payouts.',
  defaultImage: '/assets/images/mobile-icon.png',
  siteName: 'Mrs Cater – Caterer',
  locale: 'en_ZA',
  twitterHandle: '@mrscater',
  keywords: [
    'Mrs Cater caterer portal',
    'caterer dashboard South Africa',
    'manage catering profile',
    'event catering platform South Africa',
    'caterer orders management',
    'catering menu management',
    'caterer bids',
    'caterer payouts',
    'wedding catering South Africa',
    'funeral catering South Africa',
    'corporate catering South Africa',
    'verified caterer profile',
  ].join(', '),
};

/** Base JSON-LD: Organization + WebSite for caterer app. */
export function getBaseJsonLd() {
  const base =
    typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_URL
      ? String(import.meta.env.VITE_APP_URL).replace(/\/$/, '')
      : typeof window !== 'undefined'
        ? window.location.origin
        : 'https://caterer.mrscater.com';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SEO.siteName,
      url: base,
      description: SEO.defaultDescription,
      areaServed: { '@type': 'Country', name: 'South Africa' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SEO.siteName,
      url: base,
      description: SEO.defaultDescription,
    },
  ];
}

export default SEO;
